import {BankGift} from "@/store/shop/types";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";

export class GiftBankPanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 144;

    private takeButton!: SquareButton;

    constructor(scene: Phaser.Scene, x: number, y: number, bg: BankGift, callback: () => void) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.width = CU.CANVAS_WIDTH;
        this.height = 144;

        this.takeButton = SpriteUtils.scale(new SquareButton(this.scene, 530, 70, -10, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('vzjat'), false, 84 * CU.S, 84 * CU.S, 0), 0.7 / CU.S);

        this.takeButton.setCallback(() => {
            callback();
        });

        const separator = SpriteUtils.addSprite(this.scene!, 0, 148, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([separator]);

        this.add([this.takeButton]);

        const image = SpriteUtils.addImage(this.scene, 60, 70, Keys.ATLAS_BANK, 'gems-0', 0.8).setOrigin(0.5, 0.5);

        const titleLight = SpriteUtils.addImage(this.scene, 100, 15, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT).setOrigin(0, 0);
        SpriteUtils.setDispSize(titleLight,  200, 65 * CU.S);

        let titleText = TextUtils.addTextAdvanced(scene, Tr('gft'), 125, 50,
            '#FBD777', 19, 'normal', 450, 'left', 2, Fonts.BENGALY_NORMAL);
        titleText.setStroke('#8c4f19', 5);

        let countText = TextUtils.addTextAdvanced(scene, String(bg.gems), 125, 77,
            '#9a9a98', 18, 'normal', 320, 'left', 1, Fonts.GOTHIC_DEUTSCH);
        countText.setOrigin(0, 0).setStroke('#000000', 1);
        let countIcon = SpriteUtils.addSprite(this.scene!, countText.getRightCenter().x! / CU.S + 1, 72, Keys.IMG_RES_GEM_NO_SHADOW)
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(countIcon, 34 * CU.S, 34 * CU.S);

        let desc = TextUtils.addTextAdvanced(this.scene, Tr('free.gms'),
            184, 77, '#c9c9c9', 12, 'normal', 220,
            'left', 2, Fonts.MYRIADPRO_REGULAR)
            .setOrigin(0, 0);
        desc.setStroke('#2a2a2a', 2);
        this.add(desc);

        this.add([image, titleLight, titleText, countIcon, countText]);
    }

    public hideTakeButton() {
        this.takeButton.visible = false;
    }

}
